import MojitoCore from 'mojito/core';
import SettingsMenuAvantgardeImpl from './settings-menu-avantgarde.js';

/**
 * Avantgarde design style settings menu with card-style default view and appearance controls.
 *
 * @class SettingsMenuAvantgarde
 * @memberof Mojito.Modules
 */
export default MojitoCore.Presentation.UIView('SettingsMenuAvantgarde', SettingsMenuAvantgardeImpl);
